import React from 'react';
import styled from 'styled-components/macro';
import { THEME_COLORS } from '../utils/theme';
import { DubHacksFont, PrimaryFont } from './styles';

const FooterContainer = styled.div`
  text-align: center;
  padding: 40px 0;
`;

const FooterTitle = styled(DubHacksFont)`
  display: block;
  color: ${THEME_COLORS.brandPink};
  margin: 5px 0;
  font-size: max(2.5vw, 30px);
`;

const FooterDescription = styled(PrimaryFont)`
  display: block;
  color: ${THEME_COLORS.brandPink};
  margin: 5px 0;
  font-size: max(1.5vw, 20px);
`;

export const Footer: React.FC = () => {
  return (
    <FooterContainer>
      <FooterTitle>DUBHACKS</FooterTitle>
      <FooterDescription>Made with {'<3'} in Seattle</FooterDescription>
    </FooterContainer>
  );
};
